<script setup lang="ts">
const model = defineModel<string[]>({ default: () => [] });

const ATTRIBUTES = [
  { label: 'Stairs', value: 'STAIRS' },
  {
    label: 'Special Requirements (Safety, Site)',
    value: 'SPECIAL_REQUIREMENTS',
  },
  { label: 'Loading Dock Height', value: 'LOADING_DOCK_HEIGHT' },
];

function hasAttribute(value: string): boolean {
  return model.value.includes(value);
}

function toggleAttribute(value: string): void {
  model.value = model.value.includes(value)
    ? model.value.filter((v) => v !== value)
    : [...model.value, value];
}
</script>

<template>
  <fieldset
    :class="$style.stopAttributesFieldset"
    data-testid="stopAttributesFieldset"
  >
    <span :class="$style.label">Additional details</span>
    <div :class="$style.chips">
      <v-chip
        v-for="attr in ATTRIBUTES"
        :key="attr.value"
        variant="outlined"
        size="small"
        :class="[
          $style.chip,
          { [$style.chipActive]: hasAttribute(attr.value) },
        ]"
        @click="toggleAttribute(attr.value)"
      >
        <span :class="$style.chipStack">
          <span
            :class="[
              $style.chipVariant,
              { [$style.chipVariantVisible]: !hasAttribute(attr.value) },
            ]"
          >
            {{ attr.label }}
          </span>
          <span
            :class="[
              $style.chipVariant,
              { [$style.chipVariantVisible]: hasAttribute(attr.value) },
            ]"
          >
            <v-icon icon="mdi-check" size="14" :class="$style.checkIcon" />
            {{ attr.label }}
          </span>
        </span>
      </v-chip>
    </div>
  </fieldset>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.stopAttributesFieldset {
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
  .label {
    font-size: 0.875rem;
    font-weight: 500;
    color: colors.$color-text-primary;
  }
  .chips {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  .chip {
    height: 28px !important;
    border-radius: 6px !important;
    cursor: pointer;
    border-width: 1.5px !important;
    border-color: colors.$color-border-input-default !important;
    color: colors.$color-text-primary !important;
    font-weight: 600;
  }
  .chipActive {
    background-color: colors.$color-brand-200 !important;
    border-color: colors.$color-brand-200 !important;
    color: colors.$color-text-primary !important;
  }
  .chipStack {
    display: grid;
  }
  .chipVariant {
    grid-area: 1 / 1;
    display: flex;
    align-items: center;
    justify-content: center;
    visibility: hidden;
  }
  .chipVariantVisible {
    visibility: visible;
  }
  .checkIcon {
    margin-inline-end: 4px;
  }
</style>
